import React, { useState } from 'react';
import classNames from 'classnames';

import SequenceDueDate from './SequenceDueDate';
import HiddenSequenceLink from './HiddenSequenceLink';
import SequenceTitle from './SequenceTitle';
import UnitLink from './UnitLink';
import { useModel } from '../../../generic/model-store';
import { Collapsible, IconButton } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from '../messages';
import { Minus, Plus } from '@openedx/paragon/icons';
import genericMessages from '../../../generic/messages';

interface Props {
  id: string;
  first: boolean;
  sequence: {
    complete: boolean;
    description: string;
    due: string;
    showLink: boolean;
    title: string;
    hideFromTOC: boolean;
    verticalIds: string[];
  };
  courseId: string;
}

const SequenceLink: React.FC<Props> = ({
  id,
  first,
  sequence,
  courseId,
}) => {
  const {
    complete,
    description,
    due,
    showLink,
    title,
    hideFromTOC,
    verticalIds,
  } = sequence;

  const {
    courseBlocks: {
      verticals,
    },
  } = useModel('outline', courseId);
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <li>
      <div className={classNames('', { 'mt-2 pt-2 border-top border-light': !first })}>
        <Collapsible
          className="mb-2"
          styling="card-lg"
          title={(
            <div className='w-100'>
              <SequenceTitle
                complete={complete}
                showLink={showLink}
                title={title}
                sequence={sequence}
                id={id}
              />
              <SequenceDueDate due={due} id={id} description={description} />
            </div>
          )}
          open={open}
          onToggle={() => { setOpen(!open); }}
          iconWhenClosed={(
            <IconButton
              alt={intl.formatMessage(messages.openSection)}
              iconAs={Plus}
              onClick={() => { setOpen(true); }}
              size="sm"
            />
          )}
          iconWhenOpen={(
            <IconButton
              alt={intl.formatMessage(genericMessages.close)}
              iconAs={Minus}
              onClick={() => { setOpen(false); }}
              size="sm"
            />
          )}
        >
          <ol className="list-unstyled uw-list-collapse-left">
            {verticalIds.map((unitId, index) => (
              <UnitLink
                key={unitId}
                id={unitId}
                unit={verticals[unitId]}
                courseId={courseId}
                sequenceId={id}
              />
            ))}
          </ol>
        </Collapsible>        
        {hideFromTOC && (
          <HiddenSequenceLink />
        )}
      </div>
    </li>
  );
};

export default SequenceLink;
